exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#dashboard-page{max-width:900px!important}#dashboard-page .vuetify-btn-toggle{padding:30px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/pages/dashboard.vue"],"names":[],"mappings":"AACA,gBACE,yBAA4B,CAC7B,AACD,oCACI,YAAc,CACjB","file":"dashboard.vue","sourcesContent":["\n#dashboard-page {\n  max-width: 900px !important;\n}\n#dashboard-page .vuetify-btn-toggle {\n    padding: 30px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d8a10a4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/dashboard.vue
// module id = 787
// module chunks = 10